import React from 'react'
import Item from './Item'

const Items = props => {
  const { data, tooltip, lastSkuEta, promoBadgeConfig, showLoader, zipCode } = props

  return (
    <>
      {
        data &&
        data.map(
          (item, index) => (
            <Item
              index={index}
              data={item}
              key={`ShoppingCartV2_item-${item?.product?.sku || index.toString()}`}
              tooltip={tooltip}
              lastSkuEta={lastSkuEta}
              promoBadgeConfig={promoBadgeConfig}
              showLoader={showLoader}
              zipCode={zipCode}
            />
          ),
        )
      }
    </>
  )
}

export default Items
